import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { constant } from './Constants';
import cloneDeep from 'lodash.clonedeep';
import { bindActionCreators } from 'redux';
import menuAdapter from '../Adapter/MenuAdapter';
import { GlobalHeader, GlobalHeaderLogo } from './styles';
import localStorage from '../../../../../utils/localStorage';
import { Menu, Dropdown, Space, ConfigProvider, Skeleton } from 'antd';
import LayoutAction from '../../../../../modules/actions/LayoutAction';
import { API_LANGUAGE, LANDINGPAGE, UPLOAD } from '../../../../../commons/api';
import TranslationAction from '../../../../../modules/actions/TranslationAction';
import {
  CaretDownOutlined,
  FullscreenOutlined,
  GlobalOutlined,
  LogoutOutlined,
  UserOutlined
} from '@ant-design/icons';
import { logoutAction } from '../../../../../modules/actions/LogoutAction';

const SlideMenuComponent = (props) => {
  const [currentMenu, setCurrentMenu] = useState('');
  const [userProfile, setUserProfile] = useState(props.userProfile);
  const [logoPath, setLogoPath] = useState('');
  const [selectedMenu, setSelectedMenu] = useState(props.selectedMenu[0]);
  const [firstLevelMenu, setFirstLevelMenu] = useState([]);
  const [secondLevelMenu, setSecondLevelMenu] = useState([]);
  const [menuHierarchy, setMenuHierarchy] = useState({});
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [languageList, setLanguageList] = useState([]);
  const pathName = JSON.stringify(props.location.pathname);
  const showmenu = !(
    pathName.match('editpanel') !== null ||
    pathName.match('/rubus/settingsPage') !== null
  );

  useEffect(() => {
    getLanguageList();
  }, []);

  useEffect(() => {
    if (showmenu) {
      let defaultPageValueSetting = menuAdapter.setFirstDefaultPages(
        menuHierarchy,
        [],
        { key: 'Modules' }
      );
      props.layoutAction.setMenuSelection(defaultPageValueSetting);
    }
  }, [showmenu]);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      const firstLevelMenu = menuAdapter.firstMenuAdapter(menuHierarchy, props.translationCache);
      getSecondLevelMenu(menuHierarchy, props.selectedMenu[0]);
      setFirstLevelMenu(firstLevelMenu);
      setTranslationCache(props.translationCache);
    }

    if (props.menuHierarchy !== menuHierarchy) {
      const newMenuHierarchy = props.menuHierarchy;
      const firstLevelMenu = menuAdapter.firstMenuAdapter(newMenuHierarchy, props.translationCache);
      getSecondLevelMenu(newMenuHierarchy, props.selectedMenu && props.selectedMenu[0] ? props.selectedMenu[0] : "");
      setMenuHierarchy(newMenuHierarchy);
      setFirstLevelMenu(firstLevelMenu);
    }

    if (props.selectedMenu[0] !== selectedMenu) {
      if (props.selectedMenu.length >= 2) {
        setCurrentMenu(props.selectedMenu[1]);
      }
      getSecondLevelMenu(menuHierarchy, props.selectedMenu[0]);
      setSelectedMenu(props.selectedMenu[0]);
    }

    if (props.userProfile !== userProfile) {
      getRole(props.userProfile);
      setUserProfile(props.userProfile);
    }
    if (props.selectedMenu.length >= 2) {
      setCurrentMenu(props.selectedMenu[1]);
    }
  }, [props.userProfile, props.translationCache, props.menuHierarchy, props.selectedMenu]);

  const getLanguageList = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let changePassword = {
      method: 'GET',
      url: `${API_LANGUAGE.LanguageList}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(changePassword)
      .then((response) => {
        setLanguageList(response.data);
        props.translationAction.translationAuth(response.data && response.data[0].Name);
      })
      .catch(function () { });
  };

  const getSecondLevelMenu = async (menuHierarchy, selectedMenu) => {
    let menuHierarchyClone = cloneDeep(menuHierarchy);
    let secondLevelMenu = await menuAdapter.secoundMenuAdapter(
      menuHierarchyClone,
      selectedMenu || 'Modules',
      props.translationCache
    );
    setSecondLevelMenu(secondLevelMenu);

  };

  const getRole = async (userProfile) => {
    let currentSiteId = localStorage.get('currentSite');
    let logoPath =
      currentSiteId &&
        userProfile &&
        userProfile.belongsTo &&
        userProfile.belongsTo.sites &&
        userProfile.belongsTo.sites[currentSiteId] &&
        userProfile.belongsTo.sites[currentSiteId].site &&
        userProfile.belongsTo.sites[currentSiteId].site['ImageURL']
        ? userProfile.belongsTo.sites[currentSiteId].site['ImageURL']
        : '';

    setLogoPath(logoPath);
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getLandingPageById = (Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${LANDINGPAGE.GET}?Id=${Id}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        if (data && Array.isArray(data) && data[0]) {
          let LOGO = ['Modules'];
          props.layoutAction.setMenuSelection(LOGO);
          props.navigate(data[0].Path);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const onsMenuClick = (item) => {
    let menu = [props.selectedMenu[0] || "Modules", item.key];
    let defaultSecondLevel = menuAdapter.setSecondDefaultPages(
      menuHierarchy, menu, item
    );
    props.layoutAction.setMenuSelection(defaultSecondLevel);
    props.navigate(item.item.props.path);
  };

  // const languageMenu = async () => {
  //   return languageList.map((language) => ({
  //     key: language,
  //     label: language
  //   }));
  // };

  // const fetchLanguages = () => {
  //   return languageList;
  // };

  const { themeValue } = props;
  const siteId = localStorage.get('currentSite');
  const menuItemsLogOut = [
    ...(firstLevelMenu !== undefined && menuHierarchy ?
      firstLevelMenu.filter(item => item.key !== "Configuration")
        .map((fLMenu) => {
          return {
            key: fLMenu.key,
            label: translation(fLMenu.name),
          };
        })
      :
      []),
    {
      key: 'logOut',
      label: translation(constant.LogOut),
      icon: <LogoutOutlined />
    }
  ];

  const menu = {
    items: menuItemsLogOut,
    onClick: (e) => {
      if (e && e.key === "logOut") {
        props.onLogout?.();
        localStorage.clear();
        sessionStorage.clear();
        props.navigate?.('/login');
      } else {
        let defaultPageValueSetting = menuAdapter.setFirstDefaultPages(
          menuHierarchy,
          [],
          { key: e.key }
        );
        if (e && e.key === 'ApplicationSettings') {
          props.navigate('/rubus/settingsPage/Profile');
          props.layoutAction.setMenuSelection(defaultPageValueSetting);
        } else if (defaultPageValueSetting.length === 1) {
          props.layoutAction.setMenuSelection(defaultPageValueSetting);
          if (
            menuHierarchy &&
            menuHierarchy[defaultPageValueSetting[0]] &&
            menuHierarchy[defaultPageValueSetting[0]].path
          ) {
            props.navigate(menuHierarchy[defaultPageValueSetting[0]].path);
          }
        } else if (menuHierarchy && menuHierarchy[defaultPageValueSetting[0]] && defaultPageValueSetting.length >= 2) {
          props.layoutAction.setMenuSelection(defaultPageValueSetting);
          props.navigate(
            menuHierarchy[defaultPageValueSetting[0]].children[defaultPageValueSetting[1]].path
          );
        } else if (e.key === "Configuration") {
          return null;
        }
      }
    },
  };

  const handleMenuClick = ({ key }) => {
    const selectedLanguage = languageList.find(lang => lang.Code === key);
    const languageName = selectedLanguage.Name;
    props.translationAction.translationAuth(languageName);
  };

  const items = languageList && Array.isArray(languageList) ? languageList.map((language) => ({
    key: language.Code,
    label: language.Name
  })) : [];

  return (
    <ConfigProvider theme={{
      token: themeValue.token,
      components: themeValue.components,
      algorithm: themeValue.darkAlgorithm,
    }}>
      <GlobalHeader
        background={themeValue?.components?.Menu?.colorBgContainer}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    borderBlockEnd: '1px solid gray' }}
      >
        <GlobalHeaderLogo>
          {
            logoPath !== '' ?
              <img
                src={logoPath !== '' ? `${UPLOAD.Uploads}/${logoPath}` : ''}
                alt="LOGO"
                style={{
                  height: '60px',
                  maxWidth: '100%',
                  padding: '10px',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  let landingpageId =
                    userProfile &&
                      userProfile.belongsTo &&
                      userProfile.belongsTo.sites &&
                      userProfile.belongsTo.sites[siteId] &&
                      userProfile.belongsTo.sites[siteId].role &&
                      userProfile.belongsTo.sites[siteId].role.LandingPageId
                      ? userProfile.belongsTo.sites[siteId].role.LandingPageId
                      : '';
                  getLandingPageById(landingpageId);
                }}
              />
              : <Skeleton.Input active={true} />
          }
        </GlobalHeaderLogo>
        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', flex: '1 1 auto' }}>
          {
            showmenu ?
              <div
                style={{
                  flex: '1 1 auto',
                  overflowX: 'auto',
                  whiteSpace: 'nowrap',
                }}
              >
                <Menu
                  onClick={onsMenuClick}
                  selectedKeys={[currentMenu]}
                  mode="horizontal"
                  // theme={themeValue?.algorithm}
                  style={{
                    background: themeValue?.components?.Menu?.colorBgContainer,
                    color: themeValue?.components?.Menu?.itemColor,
                    borderBottom: "none",
                    lineHeight: '60px',     
                    height: '60px',             
                    overflowY: 'hidden',
                  }}
                  items={secondLevelMenu && secondLevelMenu.map((sMenu) => {
                    if (sMenu.isRedirect === true) {
                      return {
                        label: sMenu.name,
                        key: sMenu.key,
                        onClick: () => {
                          setTimeout(() => {
                            window.open(sMenu?.path, '_blank');
                          }, 1000);
                        },
                      };
                    }
                    return {
                      label: sMenu.name,
                      key: sMenu.key,
                      path: sMenu.path,
                      onClick: onsMenuClick, // Keep the existing onClick behavior for other items
                    };
                  })}
                />
              </div>
              : null
          }
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
            flexShrink: 0
          }}
        >
          {userProfile &&
            userProfile.belongsTo &&
            userProfile.belongsTo.sites &&
            Object.keys(userProfile.belongsTo.sites).length > 1 ? (
            <Dropdown
              overlay={{
                items: Object.keys(userProfile.belongsTo.sites) && Object.keys(userProfile.belongsTo.sites).length > 0 ?
                  Object.keys(userProfile.belongsTo.sites).map((siteId) => {
                    let siteDetails = userProfile.belongsTo.sites[siteId];
                    if (siteDetails && siteDetails.site && siteDetails.site.Name) {
                      return {
                        key: siteDetails.site.Name,
                        label: siteDetails.site.Name
                      };
                    } else {
                      return {
                        key: '',
                        label: ''
                      };
                    }
                  })
                  : []
              }}
            >
              <>
                <Space>
                  <div>
                    {siteId &&
                      userProfile &&
                      userProfile.belongsTo &&
                      userProfile.belongsTo.sites &&
                      userProfile.belongsTo.sites[siteId] &&
                      userProfile.belongsTo.sites[siteId].site
                      ? userProfile.belongsTo.sites[siteId].site.Name
                      : ''}
                    {''}
                    <CaretDownOutlined />
                  </div>
                </Space>
              </>
            </Dropdown>
          ) : null}

          <Dropdown menu={menu} trigger={['click']}>
            <div onClick={(e) => e.preventDefault()}>
              <span style={{ margin: '4px' }}>
                <UserOutlined
                  style={{
                    color: themeValue.token.colorText,
                    lineHeight: '72px',
                    marginTop: '13px',
                  }}
                />
                <span style={{ margin: '4px', color: themeValue.token.colorText }}>
                  {translation(
                    userProfile && userProfile.user && userProfile.user.FirstName ? userProfile.user.FirstName : ''
                  )}
                </span>
              </span>
            </div>
          </Dropdown>
          <Dropdown menu={{ items, onClick: handleMenuClick }} trigger={['click']}>
            <div>
              <GlobalOutlined
                style={{
                  color: themeValue.token.colorText,
                  lineHeight: '72px',
                  margin: '13px 10px 1px 18px'
                }}
              />
            </div>
          </Dropdown>

          <FullscreenOutlined
            title={'fullscreen'}
            onClick={() => {
              document.fullscreenEnabled =
                document.fullscreenEnabled ||
                document.mozFullScreenEnabled ||
                document.documentElement.webkitRequestFullScreen;

              if (document.fullscreenEnabled) {
                props.fullScreen(document.documentElement);
              } else {
                alert('full screen not supported');
              }
            }}
            style={{
              color: themeValue.token.colorText,
              lineHeight: '72px',
              margin: '10px'
            }}
          />
        </div>
      </GlobalHeader >
    </ConfigProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    currentSite: state.LayoutReducer.currentSite,
    selectedMenu: state.LayoutReducer.menuSelected,
    currentMenu: state.LoginReducer.userCurrentMenu,
    menuHierarchy: state.LayoutReducer.menuHierarchy,
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutAction: bindActionCreators(LayoutAction, dispatch),
    translationAction: bindActionCreators(TranslationAction, dispatch),
    onLogout: bindActionCreators(logoutAction, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SlideMenuComponent);
